const getAuthorisedUsersForReport = [
  'stellar@universal.edu.in',
  'nauka+localschooladmin@joinether.in',
  'erp.support+uhd@universal.edu.in',
  'vivek+parent1@technogise.com',
  'gaurav.rai+uahm@universal.edu.in',
  'gaurav.rai+uht@universal.edu.in',
  'varsha.jayashankar+uahm@universal.edu.in',
  'varsha.jayashankar+uht@universal.edu.in',
  'sankar+uahm@joinether.in',
  'mahesh.khairnar+admin@universal.edu.in',
  'gaurav+ab@joinether.in',
  'gaurav+acis@joinether.in',
  'gaurav+apm@joinether.in',
  'gaurav+awv@joinether.in',
  'gaurav+eisb@joinether.in',
  'gaurav+eisn@joinether.in',
  'gaurav+ihs@joinether.in',
  'gaurav+local@joinether.in',
  'gaurav+ppsb@joinether.in',
  'gaurav+sju@joinether.in',
  'gaurav+sous@joinether.in',
  'gaurav+sws-a@joinether.in',
  'gaurav+sws-b@joinether.in',
  'gaurav+sws-g@joinether.in',
  'gaurav+uahm@joinether.in',
  'gaurav+uhd@joinether.in',
  'gaurav+uhm@joinether.in',
  'gaurav+uhsa@joinether.in',
  'gaurav+uhsc@joinether.in',
  'gaurav+uht@joinether.in',
  'gaurav+usg@joinether.in',
  'gaurav+ust@joinether.in',
  'sankar+ab@joinether.in',
  'sankar+acis@joinether.in',
  'sankar+apm@joinether.in',
  'sankar+awv@joinether.in',
  'sankar+eisb@joinether.in',
  'sankar+eisn@joinether.in',
  'sankar+ihs@joinether.in',
  'sankar+local@joinether.in',
  'sankar+ppsb@joinether.in',
  'sankar+sju@joinether.in',
  'sankar+sous@joinether.in',
  'sankar+sws-a@joinether.in',
  'sankar+sws-b@joinether.in',
  'sankar+sws-g@joinether.in',
  'sankar+uahm@joinether.in',
  'sankar+uhd@joinether.in',
  'sankar+uhm@joinether.in',
  'sankar+uhsa@joinether.in',
  'sankar+uhsc@joinether.in',
  'sankar+uht@joinether.in',
  'sankar+usg@joinether.in',
  'sankar+ust@joinether.in',
  'varsha+ab@joinether.in',
  'varsha+acis@joinether.in',
  'varsha+apm@joinether.in',
  'varsha+awv@joinether.in',
  'varsha+eisb@joinether.in',
  'varsha+eisn@joinether.in',
  'varsha+ihs@joinether.in',
  'varsha+local@joinether.in',
  'varsha+ppsb@joinether.in',
  'varsha+sju@joinether.in',
  'varsha+sous@joinether.in',
  'varsha+sws-a@joinether.in',
  'varsha+sws-b@joinether.in',
  'varsha+sws-g@joinether.in',
  'varsha+uahm@joinether.in',
  'varsha+uhd@joinether.in',
  'varsha+uhm@joinether.in',
  'varsha+uhsa@joinether.in',
  'varsha+uhsc@joinether.in',
  'varsha+uht@joinether.in',
  'varsha+usg@joinether.in',
  'varsha+ust@joinether.in',
  'bhoomi+admin@joinether.in',
  'ekta+admin@joinether.in',
  'admin@bpismumbai.com',
  'jay.sharma+demo4-admin@joinether.in',
  'bhoomi+demo4-admin@joinether.in',
  'satish.wv@gmail.com',
  'abhilashhp.1991+admin@gmail.com',
  'pradeep.kumar+admin@joinether.in',
  'harshad.p+admin@joinether.in',
  'kitila+admin@nagaed.com',
  'kevisato+admin@nagaed.com',
  'vishal.m+school@joinether.in',
  'varsha+xavier-korba@joinether.in',
  'jay.sharma+xavier-korba@joinether.in',
  'pavanparimi+admin@dpsvijayawada.org',
  'nidhi.a+local@joinether.in',
  'sutirtha.c+local@joinether.in',
  'brijesh.k+admin@joinether.in',
  'nupoor2905@gmail.com',
  'mhatreamita65@gmail.com',
  'liv_ari@yahoo.com',
  'joshua.dhanraj+admin@joinether.in',
  'manju.kn+admin@joinether.in',
  'manishamalakar444@gmail.com',
  'rekhachandwani311@gmail.com',
  'mohankorba@gmail.com',
  'saigyvs+admin@gmail.com',
  'director+admin@stxavierskorba.com',
  'manager+admin@stxavierskorba.com',
  'st.xavierspschoolkorba+admin@yahoo.com',
  'madhankumar+admin@joinether.in',
  'productsupport+bpis@joinether.in',
  'productsupport+uhsk@joinether.in',
  'productsupport+ab@joinether.in',
  'productsupport+acis@joinether.in',
  'productsupport+ana@joinether.in',
  'productsupport+apm@joinether.in',
  'productsupport+awv@joinether.in',
  'productsupport+eisb@joinether.in',
  'productsupport+eisn@joinether.in',
  'productsupport+ihs@joinether.in',
  'productsupport+ppsb@joinether.in',
  'productsupport+ppsd@joinether.in',
  'productsupport+sju@joinether.in',
  'productsupport+sous@joinether.in',
  'productsupport+sps@joinether.in',
  'productsupport+sws-andheri@joinether.in',
  'productsupport+sws-bandra@joinether.in',
  'productsupport+sws-goregaon@joinether.in',
  'productsupport+uahm@joinether.in',
  'productsupport+uhd@joinether.in',
  'productsupport+uhm@joinether.in',
  'productsupport+uhsa@joinether.in',
  'productsupport+uhsc@joinether.in',
  'productsupport+uht@joinether.in',
  'productsupport+usg@joinether.in',
  'productsupport+ust@joinether.in',
  'productsupport+xavier-korba@joinether.in',
  'productsupport+cbis@joinether.in',
  'hivehsrschool+admin@gmail.com',
  'vishwas.bhatandbhat+admin@gmail.com',
  'sakib.s@cybernx.com'
];
export default getAuthorisedUsersForReport;
